import * as React from "react";

import s from "./ErrorComponent.module.scss";

interface IProps {
	error?: any;
}

export const ErrorComponent = ({ error }: IProps): JSX.Element | null => {
	if (!error) {
		return null;
	}

	return (
		<div className={s.error}>
			<div className={s.error__column}>
				<div className={s.error__message}>
					<div className={s.error__text}>{error.message || (error.type === "ServerError" ? error.data?.error : error.type)}</div>
				</div>
			</div>
		</div>
	);
};
